import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useIntl } from 'react-intl';

import { usePdpContext } from '../pdp-provider';

import messages from './messages';
import styles from './styles.cssm';

const IconSizeSelector = ({ onClick = () => {} }) => {
  const { formatNumber, formats } = useIntl();
  const { isDemystifyMenuPdpEnabled, onSizeSelect, sizeInfo } = usePdpContext();

  const { isWholeBean, pricedProductAllSizes } = sizeInfo || {};

  const getProductSizePrice = (sizeSku) =>
    isDemystifyMenuPdpEnabled && pricedProductAllSizes?.has(sizeSku)
      ? formatNumber(pricedProductAllSizes.get(sizeSku), formats.number.money)
      : '';

  return (
    <form
      className="grid grid--alignCenter grid--compactGutter mb5"
      data-e2e="size-selector"
    >
      <fieldset>
        <legend className="hiddenVisually">Size options</legend>
        {sizeInfo?.sizeNames?.map((size, index) => {
          const productSizePrice = getProductSizePrice(
            sizeInfo?.sizeSkus?.[index]
          );
          const drinkSizeImageClassName =
            styles[
              `${sizeInfo?.sizeCodes?.[index]?.toLowerCase()}-${
                sizeInfo?.productType
              }`
            ];
          const activeCircleBaseLeftMargin = 8;
          const activeCircleOffset = 72;
          const wholeBeanCircleLeftMarginOffset = isWholeBean ? 40 : 0;
          const calculatedActiveCircleOffset =
            activeCircleBaseLeftMargin +
            sizeInfo?.selectedSizeIndex * activeCircleOffset +
            wholeBeanCircleLeftMarginOffset;

          return (
            <div
              className={classNames(
                'gridItem px0 my2 relative',
                styles.sizeItem,
                {
                  [styles.active]: sizeInfo?.selectedSizeName === size,
                  [styles.wholeBean]: isWholeBean,
                }
              )}
              key={size}
            >
              {index === 0 ? (
                <div
                  className={styles.activeCircle}
                  style={{ marginLeft: calculatedActiveCircleOffset }}
                />
              ) : null}
              <label>
                <input
                  checked={sizeInfo?.selectedSizeIndex === index}
                  className={styles.radioButton}
                  data-e2e={size}
                  id={size}
                  name="size"
                  onChange={(event) => {
                    onSizeSelect(event.target.value);
                  }}
                  onClick={onClick}
                  type="radio"
                  value={size}
                />
                <div
                  className={classNames('cursor-pointer mx4 my2', {
                    [drinkSizeImageClassName]: !isWholeBean,
                    [styles.wholeBeanImage]: isWholeBean,
                  })}
                />
                {isWholeBean ? (
                  <div className="text-xs text-center">
                    <p className="text-semibold">
                      <FormattedMessage {...messages.sizeWholeBeanLabel} />
                    </p>
                    <p>{size}</p>
                  </div>
                ) : (
                  <div className="text-xs text-center">
                    <p className="text-semibold">{size}</p>
                    <p>{sizeInfo?.sizeAmounts?.[index]}</p>
                    {productSizePrice && (
                      <p className="color-black60">{productSizePrice}</p>
                    )}
                  </div>
                )}
              </label>
            </div>
          );
        })}
      </fieldset>
    </form>
  );
};

export default IconSizeSelector;
